import { useEffect, useState, useRef } from 'react'
import { View } from "base/src/components/Basic/View/view"

import { RootStateBase } from '../../../store/baseStore';

import * as S from './styles'
import { Button } from '../../../components/Button';
import { Icon } from '@iconify/react';
import { Row } from '../../../components/Basic/Row/row';
import { PARTIAL_REMOVE } from 'domain/types/base/base';
import { AppThunk } from '../../../utils/reducerUtil';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';

function ClosePartial(partialIndex: number): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: partialIndex,
            type: PARTIAL_REMOVE
        });
    };
}

const connector = connectUtil(
  (state: RootStateBase) => ({
    partial: state.BaseReducer.Partial,
  }),
  { ClosePartial }
);

export interface PartialProps extends PropsFromRedux<typeof connector> {
    stateNames: string[]
}

function Partial(props: PartialProps){
    const partialIndex = props.partial.findIndex((e) => props.stateNames.includes(e.Name));
    const partial = props.partial.find((e) => props.stateNames.includes(e.Name));

    const callBackText = typeof partial?.CallBack !== 'function' ? partial?.CallBack?.CallBackText : "Ok!";


    function handleClick(){
        if (typeof partial?.CallBack === 'function') {
            partial.CallBack();
        }else{
            partial?.CallBack.CallBack();
        }
        if(partial != null)
        props.ClosePartial(partialIndex);
    }



    const [size, setSize] = useState<{ w: number, h: number }>()
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (ref && ref.current) {
            setSize({ w: ref.current.clientWidth, h: ref.current.clientHeight })
        }
    },[])

    return (

        props.partial.find((e) => props.stateNames.includes(e.Name)) &&
        <S.Partial ref={ref} className='fullCenter'>
            <Row className='fullCenter'>
                <S.PartialText>
                    {partial &&
                        <View>{partial.Message}</View>
                    }
                </S.PartialText>
                <S.PartialText>
                    <Button style={{maxHeight:size?.h}} onClick={handleClick} type='button' iconPosition='left' size='xsm' >
                        <Icon icon="mdi-refresh" height="18px" color={"white"} />
                        {callBackText}
                    </Button>
                </S.PartialText>
            </Row>
        </S.Partial>


    )
}

export default connector(Partial);
